import { ReleaseNoteChannel } from '@shared/releaseNotes/releaseNotes.interface';
import { useReleaseNotes } from '@shared/releaseNotes/useReleaseNotes';

//* 화환 콘솔은 role과 무관하게 화환팀 채널만 본다 — 관리자가 들어와도 여기서는
//* 화환 얘기만 보이는 게 맞다 (답례품·상조 소식은 각자 콘솔에서).
//* 모듈 상수라 참조가 안정적이다 (훅 내부 useMemo 의존성에 그대로 들어간다).
export const SELLER_RELEASE_NOTE_CHANNELS: ReleaseNoteChannel[] = ['mari-seller'];

//* 읽음 여부는 콘솔별로 따로 센다 (admin 콘솔에서 읽었다고 여기 표시가 지워지면 안 됨)
export const SELLER_RELEASE_NOTE_LAST_SEEN_KEY = 'lastSeenReleaseNoteId:mari-seller';

/** 사이드바의 안 읽음 표시용 — 화환팀 채널 한정 */
export const useSellerReleaseNotes = function () {
  return useReleaseNotes(
    SELLER_RELEASE_NOTE_CHANNELS,
    SELLER_RELEASE_NOTE_LAST_SEEN_KEY,
  );
};
